import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort, Sort} from '@angular/material/sort';
import { Property } from '../../models/property';
import { IBrokerInfo } from 'app/interface/brokerinfo';
import { BrokerService } from 'services/broker.service';
import { Router } from '@angular/router';
import { UpdateBrokerIdRequest } from 'app/models/updateBrokerIdRequest';
import { EventEmitterService } from 'services/event-emitter.service';
import { ApplicationDataService } from '../../../services/application.service';
import { ErrorService } from 'services/error.service';
import { Observable } from 'rxjs/internal/Observable';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import {Clipboard} from '@angular/cdk/clipboard';
import { environment } from 'environments/environment';
import { IBrokerReferralModel } from 'app/interface/IBrokerReferralModel';

@Component({
  selector: 'app-broker-home',
  templateUrl: './broker-home.component.html',
  styleUrls: ['./broker-home.component.css'],
})
export class BrokerHomeComponent implements OnInit, AfterViewInit {
  myControl = new FormControl();
  broker: IBrokerInfo;
  brokerId: string;
  brokerIdComplete: boolean = false;
  isLoading: boolean = true;
  selectedProperty: Property = new Property();
  properties: Property[];
  options: string[] = [];
  results: Property[];
  filteredOptions: Observable<string[]>;
  public dataSource: MatTableDataSource<IBrokerReferralModel> = new MatTableDataSource<IBrokerReferralModel>([]);
  private paginator: MatPaginator;
  private sort: MatSort;
  applicationReferralUri: string;

  constructor(
    private router: Router,
    private brokerService: BrokerService,
    private eventEmitterService: EventEmitterService,
    private applicationService: ApplicationDataService,
    private clipboard: Clipboard
    ) { 
      this.brokerService.getOrCreateBroker().subscribe(res => this.setBrokerValues(res));
      this.applicationService.getProperties()
      .subscribe(res => this.onGetProperties(res.results), err => this.applicationService.handleError(err));
    }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
      this.paginator = mp;
      this.setDataSourceAttributes();
  }
  
  private setDataSourceAttributes = (): void => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
  }

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges
    .pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    if(value === ""){
      this.selectedProperty = null;
      this.applicationReferralUri = null;
    }
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  onGetProperties(properties: Property[]) {
    this.properties = properties;
    
    for (const prop of this.properties) {
      this.options.push(prop.title);
    }

    localStorage.setItem('Waitlist', JSON.stringify(properties));
  }
  copyToClipboard = () => {
    this.clipboard.copy(this.applicationReferralUri)
  }

  setBrokerValues = (resp: IBrokerInfo) => {
    if(resp.BrokerKey === null || resp.BrokerReferralId === null || resp.BrokerReferralId === ""){
      this.router.navigate(['/application/dashboard']);
    }
    else{ 
      if(resp.BrokerId !== undefined){
        this.brokerId = resp.BrokerId;
        this.brokerIdComplete = true;
      }
      this.eventEmitterService.brokerChange(true);
      this.broker = resp;
      this.brokerService.getBrokerReferrals()
      .subscribe(res => {this.updateDisplayedReferrals(res); this.isLoading = false;}, err => {this.applicationService.handleError(err); this.isLoading = false;})
    }
  }

  onSelect(value: string) {
    this.selectedProperty = this.properties.find(x => x.title === value);
    this.applicationReferralUri = `${environment.appUrl}/application/landing?unitcode=${this.selectedProperty.unit_code}&ReferralId=${this.broker.BrokerReferralId}&utm_source=broker&utm_medium=TriPOD_link`;
  }

  submitBrokerId = () =>{
    const brokerRequest = new UpdateBrokerIdRequest(this.brokerId);
    this.brokerService.updateBrokerId(brokerRequest).subscribe(res => {
      this.brokerIdComplete = true;
      this.broker.BrokerId = this.brokerId;
      this.brokerService.getBrokerReferrals()
      .subscribe(res => this.updateDisplayedReferrals(res), err => this.applicationService.handleError(err))
    })
  }

  private updateDisplayedReferrals = (data: IBrokerReferralModel[]): void => {
    this.dataSource.data = data;
  }
}
